import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React from 'react';

var _templateObject, _templateObject2;
/* Outer span that makes the border of the Radio */
var OuterSpan = styled('span')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 1.125rem;\n  width: 1.125rem;\n  position: absolute;\n  border: 2px solid ", ";\n  border-radius: 50%;\n  /* left: -1em; */\n  box-shadow: ", ";\n  transition: box-shadow 0.75s;\n  transition: border 0.75s;\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grayLight;
}, function (_ref2) {
  var error = _ref2.error,
    theme = _ref2.theme;
  return error ? "0 0 3px ".concat(theme.palette.error) : '';
}, function (_ref3) {
  var error = _ref3.error,
    theme = _ref3.theme;
  return error ? theme.palette.errorLightest : null;
});
/* Inner Span that makes the checked fill of the Radio */
var InnerSpan = styled('span')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: 0;\n  background-color: ", ";\n  position: absolute;\n  top: 0.25rem;\n  left: 0.25rem;\n  height: 0.625rem;\n  width: 0.625rem;\n  border-radius: 50%;\n  transition: box-shadow 0.75s;\n  transition: opacity 0.5s;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.primary;
});
/**
 * Custom overlay spans to act as our new styled button.
 * Inner is defaulted to opacity 0 until the preceding Radio
 * input has the checked state, which updates its opacity to 1
 */
var RadioButton = function RadioButton(_ref5) {
  var _ref5$theme = _ref5.theme,
    theme = _ref5$theme === void 0 ? themes["default"] : _ref5$theme,
    error = _ref5.error;
  return (
    /*#__PURE__*/
    // inner is before outer so it can be picked up by the css selector from the preceding real input
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InnerSpan, {
      theme: theme,
      "aria-hidden": true
    }), /*#__PURE__*/React.createElement(OuterSpan, {
      theme: theme,
      "aria-hidden": true,
      error: error
    }))
  );
};

export default RadioButton;
